import { ToastContainer as BsToastContainer } from "react-bootstrap";
import Toast from "./Toast";
import "./toast-container.scss";

const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <BsToastContainer position="top-end" className="custom-toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
          duration={toast.duration}
        />
      ))}
    </BsToastContainer>
  );
};

export default ToastContainer;
